/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
// import '../vendors/gsap.min';
import Draggable from '../vendors/Draggable.min';
// import '../vendors/ScrollTrigger.min';
import '../vendors/ScrollSmoother.min';
// import DrawSVGPlugin from '../vendors/DrawSVGPlugin.min';
import ScrollReveal from '../vendors/scrollreveal';
import SplitText from '../vendors/SplitText.min';
import './search-ajax';
import Typed from '../vendors/typed.min.js';

let lastScrollTop = 0,
	delta = 15;

jQuery( window ).on( 'scroll', function( event ) {
	if ( jQuery( window ).width() > 1003 ) {
		const headerHight = -1 * parseInt( jQuery( '.header-section' ).height() );
		let adjustment = 0;
		if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
			adjustment = 32;
		}

		if ( jQuery( window ).width() < 783 ) {
			adjustment = 46;
		}

		const st = jQuery( this ).scrollTop();
		if ( Math.abs( lastScrollTop - st ) <= delta ) {
			return;
		}
		if ( st > lastScrollTop && lastScrollTop > 50 ) {
			jQuery( '.hero-fixed-nav-ctn' ).css( 'top', 0 + adjustment );
		} else {
			jQuery( '.hero-fixed-nav-ctn' ).css( 'top', -headerHight + adjustment );
		}
		lastScrollTop = st;
	}

	if ( jQuery( document ).scrollTop() > 50 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );
jQuery.noConflict();

jQuery( function() {
	if ( jQuery( '.sliderthemegridtop' ) && jQuery( '.sliderthemegridbottom' ).length > 0 ) {
		const $themeSliderTop = jQuery( '.sliderthemegridtop .slide-track .slide' );
		const $themeSliderbottom = jQuery( '.sliderthemegridbottom .slide-track .slide' );

	    const elementCountTop = $themeSliderTop.length;
	    const elementCountBottom = $themeSliderbottom.length;
	    jQuery( ':root' ).css( '--theme-slider-top', elementCountTop );
	    jQuery( ':root' ).css( '--theme-slider-top-half', elementCountTop / 2 );
	    jQuery( ':root' ).css( '--theme-slider-bottom', elementCountBottom );
	    jQuery( ':root' ).css( '--theme-slider-bottom-half', elementCountBottom / 2 );
	}

	if ( jQuery( '.js-mongoose-slider' ).length > 0 ) {
		// Function to check if an element is in the viewport
		function isElementInViewport( el ) {
			const rect = el.getBoundingClientRect();
			return (
				rect.right >= 0 && // Element is at least partially in the viewport from the left.
				rect.left <= window.innerWidth * 0.4 // Element is up to 30% from the right.
			);
		}
		// Function to add the "draw-svg" class to an element
		function addDrawSvgClass( entries ) {
			entries.forEach( ( entry ) => {
				const element = entry.target;
				const isIntersecting = entry.isIntersecting;
				const svgElement = element.querySelector( '.mongoose-design-element' );

				if ( isIntersecting ) {
					svgElement.classList.add( 'draw-svg' );
				} else {
					svgElement.classList.remove( 'draw-svg' );
				}
			} );
		}

		// Create an Intersection Observer to monitor .slick-slide elements
		const observer = new IntersectionObserver( addDrawSvgClass, {
			root: null,
			rootMargin: '0px',
			threshold: 0.3, // Trigger when 30% of the target is visible
		} );

		// Observe all .slick-slide elements
		document.querySelectorAll( '.slick-slide' ).forEach( ( slide ) => {
			observer.observe( slide );
		} );

		// In addition, observe DOM mutations to check for changes in .mongoose-design-element
		const mutationObserver = new MutationObserver( () => {
			// Update the Intersection Observer when there are changes in the DOM
			document.querySelectorAll( '.slick-slide' ).forEach( ( slide ) => {
				observer.observe( slide );
			} );
		} );

		mutationObserver.observe( document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			characterData: true,
		} );
	}

	if ( jQuery( '.textSwapSlider' ).length > 0 ) {
		const typing = new Typed( '.textSwapSlider', {
			strings: jQuery( '.textSwapSlider' ).attr( 'data-text' ).split( ',' ),
			typeSpeed: 100,
			backSpeed: 40,
			loop: true,
		} );
	}

	if ( jQuery( window ).width() < 1180 ) {
		jQuery( '.header-search-form' ).on( 'focus', ':input', function() {
			jQuery( 'body' ).addClass( 'focused' );
		} );
		// Remove the class from the parent element when focus is lost.
		jQuery( '.header-search-form' ).on( 'blur', ':input', function() {
			jQuery( 'body' ).removeClass( 'focused' );
		} );
	}

	jQuery( '.video-popup' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		autoplay: true,
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,

	} );

	jQuery( '.cta-tile-popup' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		autoplay: true,
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,

	} );

	if ( jQuery( window ).width() < 1180 ) {
		const menuMobileIconAppend = `<button class="open-mega-menu-button"></button>`;
		const closeMenuMobileIconAppend = `<button class="close-mega-menu-button have-no-button-style">Platform</button>`;

		jQuery( '.have-mega-menu' ).each( function() {
			jQuery( this ).prepend( menuMobileIconAppend );
		} );

		jQuery( '.mega-menu' ).each( function() {
			jQuery( this ).prepend( closeMenuMobileIconAppend );
		} );

		jQuery( '.open-mega-menu-button' ).on( 'click', function() {
			jQuery( this ).siblings( '.mega-menu' ).addClass( 'show-mega-menu' );
			jQuery( 'body' ).addClass( 'show-mega-menu' );
		} );

		jQuery( '.close-mega-menu-button' ).on( 'click', function() {
			jQuery( '.mega-menu' ).removeClass( 'show-mega-menu' );
			jQuery( 'body' ).removeClass( 'show-mega-menu' );
			document.activeElement.blur();
		} );

		jQuery( document ).on( 'click', '.close-mega-menu-button , .menu-btn', function() {
			jQuery( '.mega-menu' ).removeClass( 'show-mega-menu' );
			jQuery( 'body' ).removeClass( 'show-mega-menu' );
		} );
	}

	if ( jQuery( '.hero-fixed-nav-ctn' ).length > 0 ) {
		gsap.to( '.hero-fixed-nav-ctn',
			{
				ease: 'none',
				scrollTrigger: {
					trigger: '.hero-resources-detail',
					start: 'top top',
					end: 'bottom 20%',
					// markers: true,
					onEnter: () => {
						jQuery( '.hero-fixed-nav-ctn' ).addClass( 'show-element' );
						jQuery( '.progress-container-initial' ).addClass( 'hide-when-fixed' );
					},
					onLeaveBack: () => {
						jQuery( '.hero-fixed-nav-ctn' ).removeClass( 'show-element' );
						jQuery( '.progress-container-initial' ).removeClass( 'hide-when-fixed' );
					},
				},
			}
		);
	}

	gsap.registerPlugin( DrawSVGPlugin );

	if ( jQuery( '.draw-illustration' ).length > 0 ) {
		const svgItems = gsap.utils.toArray( '.draw-illustration-leadparagraph' );
		svgItems.forEach( ( svgItem, i ) => {
			gsap.fromTo(
				svgItem,
				{
					duration: 0.5,
					drawSVG: '100% 100%',
				},
				{
					drawSVG: '100% 0',
					ease: 'none',
					duration: 1.5,
					delay: 1,
					scrollTrigger: {
						trigger: svgItem,
						start: 'top center',
						end: 'bottom 20%',
					},
				}
			);
		} );
	}

	/**
	 * Video lenth and remaining time
	 */

	let totalDurationSeconds = 0;

	jQuery( 'video' ).each( function( index, video ) {
		video.addEventListener( 'loadedmetadata', function() {
			totalDurationSeconds = video.duration;
		} );
	} );

	jQuery( 'video' ).on( 'loadedmetadata', function() {
		function secondsToHms( d ) {
			d = Number( d );
			let timelabel = 'sec';
			const h = Math.floor( d / 3600 );
			const m = Math.floor( d % 3600 / 60 );
			const s = Math.floor( d % 3600 % 60 );

			const hDisplay = h > 0 ? h + ( h == 1 ? ' : ' : ' : ' ) : '';
			const mDisplay = m > 0 ? m + ( m == 1 ? ' : ' : ' : ' ) : '';
			const sDisplay = s > 0 ? s + ( s == 1 ? ' ' : ' ' ) : '';

			if ( d > 3600 ) {
				timelabel = 'hour';
			} else if ( d > 60 && d < 3600 ) {
				timelabel = 'min';
			} else if ( d < 60 ) {
				timelabel = 'sec';
			}

			return hDisplay + mDisplay + sDisplay + timelabel;
		}

		jQuery( this ).parent().find( '.play-btn-video-length' ).text( secondsToHms( totalDurationSeconds ) );
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav .submenu-icon' ).on( 'click', function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	// Search page search value empty on button click
	jQuery( '.show-always .js-search-close' ).on( 'click', function() {
		jQuery( this ).closest( '.header-search-form' ).find( 'input[type="search"]' ).val( '' );
	} );

	/**
	 *
	 * * Video Popup
	 *
	 *
	 */

	jQuery( 'button.play-btn.playInBox' ).addClass( 'video-playing' );

	jQuery( 'button.play-btn.playInBox' ).on( 'click', function() {
		const video = jQuery( this ).prev( 'video' )[ 0 ];
		if ( video.paused ) {
			video.play();
		} else {
			video.pause();
		}

		jQuery( this ).toggleClass( 'video-playing' );
	} );

	/**
	 *
	 * * FAQs
	 *
	 *
	 */

	jQuery( '.faq__single span' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).closest( '.faq__single' ).removeClass( 'active' );
			jQuery( this )
				.siblings( '.faq__content' )
				.slideUp( 300 );
		} else {
			jQuery( '.faq__single span' ).removeClass( 'active' );
			jQuery( '.faq__single' ).removeClass( 'active' );
			jQuery( this ).closest( '.faq__single' ).addClass( 'active' );
			jQuery( '.faq__content' ).slideUp( 300 );
			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings( '.faq__content' )
				.slideDown( 300 );
		}
	} );

	/**
	 *
	 * * Tabbed Content Mobile accordian
	 *
	 *
	 */

	jQuery( '.mobile-title' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'active' ) ) {
			jQuery( this ).removeClass( 'active' );
			jQuery( this ).closest( '.mobile-title' ).removeClass( 'active' );
			jQuery( this )
				.siblings( '.tabbed-content-row' )
				.slideUp( 300 );
		} else {
			jQuery( '.mobile-title' ).removeClass( 'active' );
			jQuery( '.mobile-title' ).removeClass( 'active' );
			jQuery( this ).closest( '.mobile-title' ).addClass( 'active' );
			jQuery( '.tabbed-content-row' ).slideUp( 300 );
			jQuery( this ).addClass( 'active' );
			jQuery( this )
				.siblings( '.tabbed-content-row' )
				.slideDown( 300 );
		}
	} );

	/**
	 *
	 * * Header form
	 *
	 *
	 */

	jQuery( document ).on( 'click', function( e ) {
		if ( ! jQuery( e.target ).closest( '.header-search-form' ).length ) {
			jQuery( '.header-search-form' ).removeClass( 'show' );
		}
	} );

	jQuery( '.js-search-open' ).on( 'click', function( e ) {
		e.stopPropagation();
		jQuery( this ).prev( '.header-search-form' ).addClass( 'show' );
	} );

	jQuery( '.js-search-close' ).on( 'click', function() {
		jQuery( this ).closest( '.header-search-form' ).removeClass( 'show' );
	} );

	/**
	 *
	 * 	* Script for Add class external link
	 *
	 */

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );

	/**   - script for team */

	/**
	 *
	 * * Team Member popup
	 *
	 *
	 */

	jQuery( '.team-member' ).each( function() {
		const disCount = jQuery( this ).find( '.member-desc' ).text().split( '' ).length;
		if ( disCount > 399 ) {
			jQuery( this ).find( '.member-btn' ).find( '.button' ).removeClass( 'slide-down' );
			jQuery( this ).find( '.member-btn' ).find( '.button' ).addClass( 'have-popup' );
		} else {
			jQuery( this ).find( '.member-btn' ).find( '.button' ).addClass( 'slide-down' );
			jQuery( this ).find( '.member-btn' ).find( '.button' ).removeClass( 'have-popup' );
		}
	} );

	jQuery( '.member-btn button.slide-down' ).on( 'click', function() {
	    const $button = jQuery( this );
	    const $memberDesc = $button.parents( '.team-member' ).find( '.member-desc' );
	    $memberDesc.slideToggle();

	    const $inner = $button.find( '.inner' );
	    const innerText = $inner.text();

	    if ( innerText === 'Show more' ) {
	        $inner.text( 'Show less' );
	    } else {
	        $inner.text( 'Show more' );
	    }
	} );

	jQuery( '.member-btn .have-popup' ).on( 'click', function() {
		jQuery( '.team-popup,.popup-bg' ).removeClass( 'show' );
		jQuery( 'body,.popup-bg' ).removeClass( 'show' );
		const id = jQuery( this ).attr( 'href' );
		jQuery( id ).addClass( 'show' );
		jQuery( 'body,.popup-bg' ).addClass( 'show' );
	} );

	jQuery( document ).mouseup( function( e ) {
		const container = jQuery( '.team-popup' );
		// if the target of the click isn't the container nor a descendant of the container
		if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
			jQuery( '.team-popup,.popup-bg' ).removeClass( 'show' );
			jQuery( 'body' ).removeClass( 'show' );
		}
	} );

	jQuery.noConflict();

	jQuery( '.popup-member-close' ).on( 'click', function() {
		jQuery( '.team-popup,.popup-bg' ).removeClass( 'show' );
		jQuery( 'body' ).removeClass( 'show' );
	} );

	jQuery.noConflict();

	if ( jQuery( '.team-members.four-columns' ).length > 0 && jQuery( window ).width() < 560 ) {
		const $teamMembers = jQuery( '.team-members.four-columns' );
		jQuery( $teamMembers ).find( '.team-member' ).slice( 0, 3 ).show();
		jQuery( '#team-loadMore' ).on( 'click', function( e ) {
			e.preventDefault();
			jQuery( '.team-member:hidden' ).slice( 0, 3 ).slideDown();
			if ( jQuery( $teamMembers ).find( '.team-member:hidden' ).length == 0 ) {
				jQuery( '#team-loadMore' ).fadeOut( 'slow' );
			}
		} );
	}
	jQuery.noConflict();

	/**
	 * Theme Quote Owl Carousel Slider
	 */

	jQuery( '.js-arrows-quote' ).owlCarousel( {
		nav: true,
		dots: false,
		items: 1,
	} );

	// jQuery( '.theme-quotes' ).each( function() {
	// 	const $this = jQuery( this );
	// 	const isWide = $this.hasClass( 'theme-quote-wide' );

	// 	if ( jQuery( this ).hasClass( 'theme-quote-wide' ) ) {
	// 		jQuery( this ).owlCarousel( {
	// 			loop: false,
	// 			margin: 126,
	// 			nav: true,
	// 			dots: true,
	// 			autoplay: true,
	// 			autoplayTimeout: 8000,
	// 			items: 1,
	// 			onInitialized( event ) {
	// 				if ( isWide ) {
	// 					const total = event.item.count;
	// 					jQuery( '.wide-slide-count .wide-total-slides' ).text( ( '0' + total ).slice( -2 ) );
	// 					jQuery( '.wide-slide-count .wide-current-slide' ).text( ( '0' + ( event.item.index + 1 ) ).slice( -2 ) );
	// 				}
	// 			},
	// 			onChanged( event ) {
	// 				if ( isWide ) {
	// 					jQuery( '.wide-slide-count .wide-current-slide' ).text( ( '0' + ( event.item.index + 1 ) ).slice( -2 ) );
	// 				}
	// 			},

	// 		} );
	// 	} else {
	// 		jQuery( this ).owlCarousel( {
	// 			loop: true,
	// 			margin: 126,
	// 			nav: true,
	// 			dots: true,
	// 			autoplay: true,
	// 			autoplayTimeout: 8000,
	// 			items: 1,
	// 		} );
	// 	}
	// } );

	jQuery( '.theme-quotes' ).each( function() {
		const $this = jQuery( this );
		const isWide = $this.hasClass( 'theme-quote-wide' );

		if ( isWide ) {
			$this.slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				autoplay: true,
				autoplaySpeed: 8000,
				infinite: false,
			} );

			const total = ( '0' + $this.slick( 'getSlick' ).slideCount ).slice( -2 );
			jQuery( '.wide-slide-count .wide-total-slides' ).text( total );

			$this.on( 'afterChange', function( event, slick, currentSlide ) {
				const current = ( '0' + ( currentSlide + 1 ) ).slice( -2 );
				jQuery( '.wide-slide-count .wide-current-slide' ).text( current );
			} );

			const current = ( '0' + 1 ).slice( -2 );
			jQuery( '.wide-slide-count .wide-current-slide' ).text( current );
		} else {
			$this.owlCarousel( {
				loop: true,
				margin: 126,
				nav: true,
				dots: true,
				autoplay: true,
				autoplayTimeout: 8000,
				items: 1,
			} );
		}
	} );

	/**
	 * Footer CTA Slider
	 */

	jQuery( '.cta-slider' ).owlCarousel( {
		loop: true,
		margin: 12,
		nav: false,
		dots: false,
		autoplay: true,
		items: 2,
		slideTransition: 'linear',
		autoplayTimeout: 4000,
		autoplaySpeed: 4000,
		mouseDrag: false,
		stagePadding: 70,
		autoWidth: true,
		pauseOnDotsHover: false,
		center: true,
	} );

	if ( jQuery( window ).width() < 1003 ) {
		jQuery( '.cta-slide' ).owlCarousel( {
			loop: true,
			margin: 10,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			center: true,
		} );
	}

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.js-resources-slider' ).owlCarousel( {
			margin: 24,
			nav: true,
			dots: false,
			item: 3,
		} );
	}

	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.mega-menu.sub-menu' ).addClass( 'focused' );
		} );

	jQuery( '.menu-item' ).not( '.menu-item-has-children' ).find( 'a' )
		.focus( function() {
			jQuery( '.mega-menu.sub-menu' ).removeClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	jQuery( '.js-logos-scroll' ).slick( {
		arrows: false,
		variableWidth: true,
		speed: 3000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		infinite: true,
		centerMode: false,
	} );

	jQuery( '.js-mongoose-slider' ).slick( {
		arrows: false,
		variableWidth: true,
		speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		infinite: true,
		pauseOnDotsHover: false,
	} );

	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.cta-logos ' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 1500,
			autoplaySpeed: 1500,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			margin: 16,
			pauseOnDotsHover: false,
			centerMode: true,
		} );

		jQuery( '.show-at-desktop ' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			margin: 50,
			pauseOnDotsHover: false,
			center: true,

		} );

		jQuery( '.cta-slide-reverse' ).owlCarousel( {
			loop: true,
			margin: 10,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			pauseOnDotsHover: false,
			rtl: true,
			center: true,

		} );
	}

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.js-quote-grid-slider ' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			autoplayHoverPause: true,
		} );

		jQuery( '.reverse-slide' ).owlCarousel( {
			loop: true,
			nav: false,
			dots: false,
			autoplay: true,
			items: 2,
			slideTransition: 'linear',
			autoplayTimeout: 4000,
			autoplaySpeed: 4000,
			mouseDrag: false,
			stagePadding: 70,
			autoWidth: true,
			rtl: true,
			autoplayHoverPause: true,
		} );
	}

	/**
	 *
	 * * Theme quote arrows
	 *
	 *
	 */

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.platform-nav' ).on( 'init', function( event, slick ) {
			jQuery( '.platform-nav .slick-slide.slick-current' ).addClass(
				'is-active'
			);
		} ).slick( {
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: false,
			arrows: false,
			touchThreshold: 100,
			variableWidth: true,
			focusOnSelect: false,
			speed: 300,
			autoWidth: true,
			autoplay: true,
			autoplaySpeed: 18000,
			pauseOnHover: false,

		} );

		jQuery( '.platform-content' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			touchThreshold: 100,
			fade: true,
			speed: 400,
			cssEase: 'linear',
			autoplay: true,
			autoplaySpeed: 18000,
			pauseOnHover: false,
			dots: false,
			arrows: false,
		} );

		jQuery( '.platform-content' ).on(

			'afterChange',
			function( event, slick, currentSlide ) {
				jQuery( '.platform-nav' ).slick( 'slickGoTo', currentSlide );
				const currrentNavSlideElem =
					'.platform-nav .slick-slide[data-slick-index="' +
					currentSlide +
					'"]';
				jQuery( '.platform-nav .slick-slide.is-active' ).removeClass(
					'is-active'
				);
				jQuery( currrentNavSlideElem ).addClass( 'is-active' );
			}
		);

		jQuery( '.platform-nav' ).on( 'click', '.slick-slide', function( event ) {
			event.preventDefault();
			const goToSingleSlide = jQuery( this ).data( 'slick-index' );

			jQuery( '.platform-content' ).slick( 'slickGoTo', goToSingleSlide );
		} );
	}

	// /**
	//  *
	//  * * Theme quote arrows
	//  *
	//  *
	//  */

	jQuery( '.sc-one' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.sc-two',
		arrows: true,
		dots: false,
		focusOnSelect: true,
		infinite: false,
		adaptiveHeight: true,
	} );

	jQuery( '.sc-two' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.sc-one',
		dots: false,
		arrows: false,
		infinite: false,
		fade: true,
		adaptiveHeight: true,
	} );

	// jQuery.noConflict();

	if ( jQuery( '#progressBar, #progressBar2' ).length > 0 ) {
		function progressBarScroll() {
			const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
			const bodyHeight = document.documentElement.clientHeight;
			const footerHeight = jQuery( '#footer-section' ).outerHeight() || 0; // Get the height of the footer

			const height = document.documentElement.scrollHeight - bodyHeight - footerHeight; // Subtract footer height
			const scrolled = ( winScroll / height ) * 100;
			document.getElementById( 'progressBar' ).style.width = scrolled + '%';
			document.getElementById( 'progressBar2' ).style.width = scrolled + '%';
		}

		window.onscroll = function() {
			progressBarScroll();
		};
	}
	jQuery.noConflict();

	/**
	 *
	 * gravity form label up down on focus
	 *
	 */

	jQuery( 'input[type="text"],input[type="email"],input[type="tel"],textarea' ).each( function() {
		jQuery( this ).on( 'focus', function() {
			jQuery( this ).parent().parent( '.gfield' ).addClass( 'active' );
		} );
		jQuery( this ).on( 'blur', function() {
			if ( jQuery( this ).val().length == 0 ) {
				jQuery( this ).parent().parent( '.gfield' ).removeClass( 'active' );
			}
		} );
		if ( jQuery( this ).val() != '' ) {
			jQuery( this ).parent( '.css' ).addClass( 'active' );
		}
	} );

	jQuery.noConflict();

	/**
	 *
	 * Hubspot form label up down on focus
	 *
	 */

	setTimeout( () => {
		jQuery( 'input[type="text"],input[type="email"],input[type="tel"],textarea' ).each( function() {
			jQuery( this ).on( 'focus', function() {
				jQuery( this ).parent().parent( '' ).addClass( 'active' );
			} );
			jQuery( this ).on( 'blur', function() {
				if ( jQuery( this ).val().length == 0 ) {
					jQuery( this ).parent().parent( '' ).removeClass( 'active' );
				}
			} );
			if ( jQuery( this ).val() != '' ) {
				jQuery( this ).parent( '.css' ).addClass( 'active' );
			}
		} );
	}, 500 );

	jQuery.noConflict();

	/**
	 *
	 * * Tabbed Content
	 *
	 */

	jQuery( '.tabbed-content' ).organicTabs( {
		speed: 200,
	} );

	/**
	 *
	 * * Lead paragraph Fancy
	 *
	 */

	if ( jQuery( '.leadpara-item' ).length > 0 ) {
		const leadParaItems = document.querySelectorAll( '.leadpara-item' );

		leadParaItems.forEach( ( item, index ) => {
			gsap.to( item, {
				scrollTrigger: {
					trigger: item,
					start: 'top center',
					endTrigger: item,
					end: 'bottom center',
					scrub: true,
					pin: false,
					onEnter: () => item.classList.add( 'active' ),
					// onLeaveBack: () => item.classList.remove('active'),
				},
				duration: 1,
			} );
		} );
	}

	// Scrolling text

	if ( jQuery( window ).width() > 1003 ) {
		gsap.registerPlugin( ScrollTrigger );
		if ( jQuery( '.js-scroll-row' ).length > 3 ) {
			const cards = gsap.utils.toArray( '.js-scroll-row' );
			const spacer = 5;
			const minScale = 0.9;
			const distributor = gsap.utils.distribute( { base: minScale, amount: 0.15 } );

			cards.forEach( ( card, index ) => {
				const increment = index + 1;
				const scaleVal = distributor( index, cards[ index ], cards );

				const tween = gsap.to( card, {
					scrollTrigger: {
						trigger: card,
						start: `top 90px  top 20%`,
						scrub: 1,
						// markers: true,
						endTrigger: '.container2',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
						onEnter: () => {
							jQuery( '#scroller-content-' + increment ).addClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
						onLeaveBack: () => {
							jQuery( '#scroller-content-' + increment ).removeClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
					},
					ease: 'linear',
					scale: scaleVal,
				} );

				// gsap.set(card, { top: '130px' });
			} );
			if ( jQuery( '.scroller-indicators' ).length > 0 ) {
				gsap.to( '.scroller-indicators', {
					scrollTrigger: {
						trigger: '.scroller-indicators',
						start: `center center`,
						scrub: 2,
						endTrigger: '.scroller-ctn',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
					},
					ease: 'linear',
				} );
			}
		} else {
			const cards = gsap.utils.toArray( '.js-scroll-row' );
			const spacer = 5;
			const minScale = 0.9;
			const distributor = gsap.utils.distribute( { base: minScale, amount: 0.05 } );

			cards.forEach( ( card, index ) => {
				const increment = index + 1;
				const scaleVal = distributor( index, cards[ index ], cards );

				const tween = gsap.to( card, {
					scrollTrigger: {
						trigger: card,
						start: `top 90px  top 20%`,
						scrub: 1,
						// markers: true,
						endTrigger: '.container2',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
						onEnter: () => {
							jQuery( '#scroller-content-' + increment ).addClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
						onLeaveBack: () => {
							jQuery( '#scroller-content-' + increment ).removeClass( 'active' );
							jQuery( '.scroller-indicator' ).removeClass( 'active' );
							jQuery( '.scroller-indicator-' + increment ).addClass( 'active' );
						},
					},
					ease: 'linear',
					scale: scaleVal,
				} );

				// gsap.set(card, { top: '130px' });
			} );

			if ( jQuery( '.scroller-indicators' ).length > 0 ) {
				gsap.to( '.scroller-indicators', {
					scrollTrigger: {
						trigger: '.scroller-indicators',
						start: `center center`,
						scrub: 2,
						endTrigger: '.scroller-ctn',
						end: `bottom top+=${ 654 + ( cards.length * spacer ) }`,
						pin: true,
						pinSpacing: false,
					},
					ease: 'linear',
				} );
			}
		}
	}

	// Iat image

	// gsap.registerPlugin( ScrollTrigger );
	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.js-iat-image' ).length > 0 ) {
			gsap.to( '.js-iat-image', {
				y: '-150px',
				ease: 'power1.out',
				scrollTrigger: {
					trigger: '.js-iat-image',
					start: 'top -40% bottom',
					end: 'top -70%  top',
					scrub: true,
					// markers: true,
				},
			} );
		}
		// Iat Content
		if ( jQuery( '.js-iat-quote-content' ).length > 0 ) {
			gsap.to( '.js-iat-quote-content', {
				y: '-150px',
				ease: 'power1.out',
				scrollTrigger: {
					trigger: '.js-iat-quote-content',
					start: 'top 80% bottom',
					end: 'top 40% top',
					scrub: true,
				},
			} );
		}
	}

	// script for progress bar for owl dots
	const progressbarCircle = `<svg class="active" width="24px" height="24px" viewBox="0 0 24 24" preserveAspectRatio="none">
		  <circle cx="12" cy="12px" r="10" stroke="#37BA95" stroke-width="1.5" fill="white" />
		</svg>`;

	jQuery( '.theme-quotes  .owl-dots  .owl-dot' ).each( function() {
		jQuery( this ).prepend( '<div class="svg-container">' + progressbarCircle + '</div>' );
	} );

	/**
	 *
	 * 	* Script for stats animation
	 *
	 */

	const a = [];
	function isElementInViewport( el ) {
		const rect = el.getBoundingClientRect();
		return rect.top >= 0 && rect.left >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) && rect.right <= ( window.innerWidth || document.documentElement.clientWidth );
	}

	if ( jQuery( '.stat-heading' ).length > 0 ) {
		jQuery( window ).scroll( function() {
			jQuery( '.stat-heading' ).each( function( index ) {
				if ( ! a[ index ] && isElementInViewport( this ) ) {
					jQuery( this ).find( '.number' ).each( function() {
						const $this = jQuery( this ),
							countTo = $this.attr( 'data-number' );
						jQuery( {
							countNum: $this.text(),
						} ).animate( {
							countNum: countTo,
						}, {
							duration: 2000,
							easing: 'swing',
							step() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
							complete() {
								$this.text( Math.ceil( this.countNum ).toLocaleString( 'en' ) );
							},
						} );
					} );
					a[ index ] = true;
				}
			} );
		} );
	}

	jQuery.noConflict();

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.hero-plan:nth-child(1) .js-plan-all-features' ).text( 'Show Less' );
		jQuery( '.hero-plan:nth-child(1) .js-plan-all-features' ).addClass( 'show-less-button' );

		jQuery( '.js-plan-all-features' ).click( function() {
			const heroPlan = jQuery( this ).parents( '.hero-plan' );
			jQuery( this ).toggleClass( 'show-less-button' );
			heroPlan.find( '.plan-detail' ).slideToggle();

			if ( jQuery( this ).text() === 'All Features' ) {
				jQuery( this ).text( 'Show Less' );
			} else {
				jQuery( this ).text( 'All Features' );
			}
		} );
	}

	if ( jQuery( '.video-testi-slider' ).length > 0 ) {
		jQuery( '.video-testi-slider' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-hidden' );
	}

	if ( jQuery( '.theme-quote-wide' ).length > 0 ) {
		jQuery( '.theme-quote-wide' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-hidden' );
	}

	if ( jQuery( '.video-testi-slider' ).length > 0 && jQuery( window ).width() > 1003 ) {
		// Video Testimonial Slider
		const transitionDuration = 800;
		let isTransitioning = false;
		let isFirstLoad = true;
		let lastInteractionWasKeyboard = false;

		const slides = Array.from( document.querySelectorAll( '.video-testi-slide' ) );
		const wrapper = document.querySelector( '.video-testi-slider' );

		// const updateSliderPosition = () => {
		// 	const activeSlide = document.querySelector( '.video-testi-slide.active' );
		// 	const activeIndex = slides.indexOf( activeSlide );
		// 	const offset = 14.125 * activeIndex; // 214px + 12px = 226px => 22.6rem

		// 	wrapper.style.transform = `translateX(-${ offset }rem)`;

		// 	slides.forEach( ( slide, index ) => {
		// 		const isActive = index === activeIndex;
		// 		slide.classList.toggle( 'active', isActive );
		// 		slide.setAttribute( 'aria-hidden', ! isActive );
		// 		toggleFocusableElements( slide, isActive );
		// 	} );

		// 	if ( ! isFirstLoad && lastInteractionWasKeyboard ) {
		// 		setTimeout( () => {
		// 			activeSlide.focus();
		// 		}, transitionDuration );
		// 	}
		// };

		const updateSliderPosition = () => {
			const activeSlide = document.querySelector( '.video-testi-slide.active' );
			const activeIndex = slides.indexOf( activeSlide );
			const offset = 14.125 * activeIndex;

			wrapper.style.transform = `translateX(-${ offset }rem)`;

			slides.forEach( ( slide, index ) => {
				const isActive = index === activeIndex;
				slide.classList.toggle( 'active', isActive );
				slide.setAttribute( 'aria-hidden', ! isActive );
				toggleFocusableElements( slide, isActive );
			} );

			// Disable or enable buttons
			const prevBtn = document.querySelector( '.video-testi-slider-buttons .prev-slide' );
			const nextBtn = document.querySelector( '.video-testi-slider-buttons .next-slide' );

			if ( activeIndex === 0 ) {
				prevBtn.setAttribute( 'disabled', 'true' );
			} else {
				prevBtn.removeAttribute( 'disabled' );
			}

			if ( activeIndex === slides.length - 1 ) {
				nextBtn.setAttribute( 'disabled', 'true' );
			} else {
				nextBtn.removeAttribute( 'disabled' );
			}

			if ( ! isFirstLoad && lastInteractionWasKeyboard ) {
				setTimeout( () => {
					activeSlide.focus();
				}, transitionDuration );
			}
		};

		const goToSlide = ( targetSlide ) => {
			if ( isTransitioning ) {
				return;
			}
			isTransitioning = true;
			isFirstLoad = false;

			const current = document.querySelector( '.video-testi-slide.active' );
			if ( current ) {
				current.classList.remove( 'active' );
			}

			targetSlide.classList.add( 'active' );
			updateSliderPosition();

			setTimeout( () => {
				isTransitioning = false;
			}, transitionDuration );
		};

		const getAdjacentSlide = ( direction ) => {
			const currentIndex = slides.findIndex( ( s ) => s.classList.contains( 'active' ) );
			const newIndex = ( currentIndex + direction + slides.length ) % slides.length;
			return slides[ newIndex ];
		};

		const toggleFocusableElements = ( slide, enable ) => {
			const focusable = slide.querySelectorAll(
				'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
			);
			focusable.forEach( ( el ) => {
				if ( enable ) {
					const originalTabindex = el.getAttribute( 'data-original-tabindex' );
					if ( originalTabindex !== null ) {
						originalTabindex === ''
							? el.removeAttribute( 'tabindex' )
							: el.setAttribute( 'tabindex', originalTabindex );
						el.removeAttribute( 'data-original-tabindex' );
					}
					el.disabled = false;
				} else {
					if ( ! el.hasAttribute( 'data-original-tabindex' ) ) {
						el.setAttribute( 'data-original-tabindex', el.getAttribute( 'tabindex' ) || '' );
					}
					el.setAttribute( 'tabindex', '-1' );
					el.disabled = true;
				}
			} );
		};

		// Event listeners for arrows
		document.querySelector( '.video-testi-slider-buttons .next-slide' ).addEventListener( 'click', () => {
			lastInteractionWasKeyboard = false;
			goToSlide( getAdjacentSlide( 1 ) );
		} );

		document.querySelector( '.video-testi-slider-buttons .prev-slide' ).addEventListener( 'click', () => {
			lastInteractionWasKeyboard = false;
			goToSlide( getAdjacentSlide( -1 ) );
		} );

		// Slide click or keyboard interaction
		slides.forEach( ( slide ) => {
			slide.addEventListener( 'click', () => {
				lastInteractionWasKeyboard = false;
				goToSlide( slide );
			} );

			slide.addEventListener( 'keydown', ( e ) => {
				if ( slide.classList.contains( 'active' ) ) {
					if ( e.key === 'ArrowRight' ) {
						lastInteractionWasKeyboard = true;
						goToSlide( getAdjacentSlide( 1 ) );
					}
					if ( e.key === 'ArrowLeft' ) {
						lastInteractionWasKeyboard = true;
						goToSlide( getAdjacentSlide( -1 ) );
					}
				}

				if ( ( e.key === 'Enter' || e.key === ' ' ) && ! slide.classList.contains( 'active' ) ) {
					lastInteractionWasKeyboard = true;
					goToSlide( slide );
				}
			} );
		} );

		updateSliderPosition();
	}

	if ( jQuery( '.video-testi-slider' ).length > 0 && jQuery( window ).width() < 1004 ) {
		jQuery( '.video-testi-slider' ).slick( {
			dots: false,
			infinite: false,
			arrows: false,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: false,
		} );

		jQuery( '.video-testi-slider-buttons .prev-slide' ).on( 'click', function() {
			jQuery( '.video-testi-slider' ).slick( 'slickPrev' );
		} );

		jQuery( '.video-testi-slider-buttons .next-slide' ).on( 'click', function() {
			jQuery( '.video-testi-slider' ).slick( 'slickNext' );
		} );

		function updateSlideNumberAndButtons() {
			const $slider = jQuery( '.video-testi-slider' );
			const currentSlide = $slider.slick( 'slickCurrentSlide' );
			const totalSlides = $slider.slick( 'getSlick' ).slideCount;

			jQuery( '.current-slide' ).text( ( '0' + ( currentSlide + 1 ) ).slice( -2 ) );
			jQuery( '.total-slides' ).text( ( '0' + totalSlides ).slice( -2 ) );

			// Disable prev button on first slide
			if ( currentSlide === 0 ) {
				jQuery( '.prev-slide' ).addClass( 'slick-arrow-disable' );
			} else {
				jQuery( '.prev-slide' ).removeClass( 'slick-arrow-disable' );
			}

			// Disable next button on last slide
			if ( currentSlide === totalSlides - 1 ) {
				jQuery( '.next-slide' ).addClass( 'slick-arrow-disable' );
			} else {
				jQuery( '.next-slide' ).removeClass( 'slick-arrow-disable' );
			}
		}

		updateSlideNumberAndButtons();

		jQuery( '.video-testi-slider' ).on( 'afterChange', function() {
			updateSlideNumberAndButtons();
		} );
	}

	if ( jQuery( '.iat-scrolling' ).length > 0 && jQuery( window ).width() > 1003 ) {
		jQuery( '.iat-scrolling-content' ).each( function() {
			gsap.to( jQuery( ".iat-scrolling-image[data-id='" + this.id + "']" )[ 0 ], {
				scrollTrigger: {
					trigger: this,
					start: 'top 50%',
					end: 'top 20%',
					scrub: false,
					onEnter: () => {
						jQuery( '.iat-scrolling-image' ).removeClass( 'active' );
						jQuery( ".iat-scrolling-image[data-id='" + this.id + "']" ).addClass( 'active' );
					},
					onLeaveBack: () => {
						jQuery( '.iat-scrolling-image' ).removeClass( 'active' );
						jQuery( ".iat-scrolling-image[data-id='" + this.id + "']" ).addClass( 'active' );
					},
				},
			} );

			gsap.to( this, {
				opacity: 1,
				scrollTrigger: {
					trigger: this,
					start: 'top 50%',
					end: 'top 30%',
					scrub: true,
				},
			} );
		} );

		jQuery( '.iat-scrolling-content' ).each( function() {
			const target = jQuery( ".iat-count[data-id='" + this.id + "']" );

			gsap.to( target[ 0 ], {
				scrollTrigger: {
					trigger: this,
					start: 'top 50%',
					end: 'top 20%',
					onEnter: () => {
						jQuery( '.iat-count' ).removeClass( 'active' );
						jQuery( ".iat-count[data-id='" + this.id + "']" ).addClass( 'active' );
					},
					onLeaveBack: () => {
						jQuery( '.iat-count' ).removeClass( 'active' );
						jQuery( ".iat-count[data-id='" + this.id + "']" ).addClass( 'active' );
					},
				},
			} );
		} );

		if ( jQuery( window ).width() > 1004 ) {
			if ( jQuery( '.iat-scrolling-content-area' ).length > 0 ) {
				const boxesHeight = jQuery( '.iat-scrolling-content-area' ).outerHeight();
				const contentHeight = jQuery( '.iat-scrolling-content-area' ).outerHeight() - 616;
				const endValue = boxesHeight - contentHeight;

				gsap.to( '.iat-scrolling-nav', {
					scrollTrigger: {
						trigger: '.iat-scrolling-nav',
						start: 'top 45%',
						end: `+=${ contentHeight }px`,
						pin: true,
						scrub: 1,
					},
				} );
			}
		}
	}

	if ( jQuery( '.iat-tabs' ).length > 0 ) {
		jQuery( '.iat-tab-item:nth-child(1)' ).addClass( 'current' );
		jQuery( '.iat-tab-item:nth-child(1) .iat-tab-item-content' ).show();

		jQuery( '.iat-tab-button' ).on( 'click', function() {
			const t = jQuery( this ).closest( '.iat-tab-item' ).data( 'tab-target' );
			jQuery( '.iat-tab-item' ).removeClass( 'current' );
			jQuery( '.iat-tab-item-content' ).slideUp( 1000 );
			jQuery( this ).closest( '.iat-tab-item' ).find( '.iat-tab-item-content' ).slideDown( 1000 );
			jQuery( this ).closest( '.iat-tab-item' ).addClass( 'current' );
			jQuery( '.tabs-image .tab-image[data-tab-target="' + t + '"]' ).addClass( 'current' );
			jQuery( '.tab-image' ).hide();
			jQuery( '.iat-tab-image' ).removeClass( 'current' );
			jQuery( t ).fadeIn().addClass( 'current' );
		} );

		jQuery( '.iat-tab-button' ).on( 'keydown', function( e ) {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				jQuery( this ).click();
			}
		} );

		if ( jQuery( window ).width() > 1003 ) {
			function updateSectors() {
				const sectors = document.querySelectorAll( '.sector' );
				const sectorCount = sectors.length;
				const angle = 360 / sectorCount;
				const skewAngle = 90 - angle;

				sectors.forEach( ( sector, index ) => {
					sector.style.transform = `rotate(${ index * angle + 17 }deg) skew(${ skewAngle }deg)`;
				} );
			}

			updateSectors();

			let currentSectorIndex = 0;
			const sectors = jQuery( '.iat-tab-button' );
			const sectorCount = sectors.length;

			function autoplay() {
				currentSectorIndex = ( currentSectorIndex + 1 ) % sectorCount;
				sectors.eq( currentSectorIndex ).trigger( 'click' );
			}

			let autoplayInterval = setInterval( autoplay, 5000 );

			function resetAutoplay() {
				clearInterval( autoplayInterval );
				autoplayInterval = setInterval( autoplay, 5000 );
			}

			sectors.eq( currentSectorIndex ).trigger( 'click' );

			sectors.on( 'click', function() {
				currentSectorIndex = sectors.index( this );

				resetAutoplay();
			} );
		}
	}

	if ( jQuery( '.iat-collage-ctn' ).length > 0 && jQuery( window ).width() < 1004 ) {
		jQuery( '.iat-collage-ctn' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-hidden' );
	}
} );

jQuery( document ).ready( function() {
	jQuery( '.platform-mega-menu' ).each( function() {
		const element = jQuery( this );
		console.log( element );
		const html = element.html();
		const classes = element.attr( 'class' );
		const id = element.attr( 'id' );
		if ( element.children.length > 1 ) {
			jQuery( this ).parent().find( '.submenu-icon' ).remove();
			jQuery( this ).parent().append( '<div  id="' + id + '" class="' + classes + '">' + html + '</div>' );
			jQuery( this ).parent().find( 'ul.mega-menu' ).remove();
		}
	} );

	if ( jQuery( window ).width() > 1003 ) {
		if ( jQuery( '.gravity__content__bottom'.length > 0 ) ) {
			new AnimationScroll( {
				selector: '.gravity__content__bottom',
				onLoad: false,
				onscroll: true,
				trigger: 0,
				transform: '0',
				// draggable: true,
				gravity: {
					selector: '.applyGravity',
					containerSelector: '.gravity__content__bottom',
					speed: 0.1,
					transform: '15xvw',
					duration: 1,
					// draggable: true,
				},
			} );
		}
	}

	if ( jQuery( window ).width() > 1180 && ! jQuery( '.page-template-template-demo' ).length ) {
		gsap.to( '.main-section', {
			scale: 0.9,
			ease: 'none',
			duration: 1,
			scrollTrigger: {
				trigger: '.scroll-trigger-animate',
				start: 'bottom bottom 300px',
				end: '+=100%',
				scrub: 1,
				// markers: true,
				onEnter: () => {
					jQuery( '.main-section' ).removeClass( 'animation-on' );
					jQuery( '.hero-jumplinks-bar' ).addClass( 'hide-bar' );
				},
				onLeaveBack: () => {
					jQuery( '.main-section' ).addClass( 'animation-on' );
					jQuery( '.hero-jumplinks-bar' ).removeClass( 'hide-bar' );
				},
			},
		} );
	}

	if ( jQuery( window ).width() > 1180 && ! jQuery( '.page-template-template-demo' ).length ) {
		gsap.to( '.footer-section', {
			zIndex: 0,
			ease: 'none',
			scrollTrigger: {
				trigger: '.scroll-trigger-animate',
				start: 'bottom bottom 300px',
				end: '+=90%',
				scrub: 1,
			},
		} );
	}
} );

function applyYearSplitEffect() {
	jQuery( '.milestone_cont-year' ).each( function() {
		const currentYearElem = jQuery( this );
		const yearText = currentYearElem.text().trim();

		if ( ! yearText ) {
			return;
		}

		let newYearHTML = '';
		yearText.split( '' ).forEach( ( digit ) => {
			newYearHTML += `<span class="digit-wrap"><span class="digit">${ digit }</span></span>`;
		} );

		currentYearElem.html( newYearHTML );
		currentYearElem.find( '.digit' ).css( { transform: 'translateY(0%)' } );
	} );
}

jQuery( document ).ready( function() {
	if ( jQuery( '.milestones'.length > 0 ) ) {
		applyYearSplitEffect();

		const milestones = [];
		const paginationContainer = jQuery( '.owl-dots' );
		let autoSlideInterval;
		let currentIndex = 0;
		let slideDirection = 'up';

		gsap.set( '.milestone_image img', { rotate: -10 } );

		jQuery( '.hide-milestones .milestone_data' ).each( function( index ) {
			const year = jQuery( this ).find( '.milestone_cont-year' ).text().trim();
			const text = jQuery( this ).find( '.milestone_text p' ).html();
			const imgSrc = jQuery( this ).find( '.milestone_image img' ).attr( 'src' );

			milestones.push( { year, text, img: imgSrc } );

			const paginationButton = `
			<button role="button" class="owl-dot" data-index="${ index }">
				<svg width="24px" height="24px" viewBox="0 0 24 24" preserveAspectRatio="none">
					<circle class="no-animate" cx="12" cy="12" r="10" stroke="#717172" stroke-width="1.5" fill="none"></circle>
					<circle cx="12" cy="12" r="10" stroke="#37BA95" stroke-width="1.5" fill="none"></circle>
				</svg>
				<span></span>
				<div class="tooltip">${ year }</div>
			</button>`;
			paginationContainer.append( paginationButton );
		} );

		jQuery( '.milestone_year-wrap .owl-dots' ).after( `
		<div class="owl-nav">
			<button type="button" role="presentation" aria-label="Nav Arrows" class="owl-prev"></button>
			<button type="button" role="presentation" aria-label="Nav Arrows" class="owl-next"></button>
		</div>` );

		jQuery( '.milestone_year-wrap' ).append( '<div class="slider-counter"></div>' );

		function updateCounter() {
			if ( window.innerWidth <= 748 ) {
				jQuery( '.owl-dots' ).hide();
				const formattedIndex = String( currentIndex + 1 ).padStart( 2, '0' );
				jQuery( '.slider-counter' ).show().html( `<span>${ formattedIndex }</span> / ${ String( milestones.length ).padStart( 2, '0' ) }` );
			} else {
				jQuery( '.owl-dots' ).show();
				jQuery( '.slider-counter' ).hide();
			}
		}

		function updateNavButtons() {
			jQuery( '.owl-prev' ).toggleClass( 'disabled', currentIndex === 0 );
			jQuery( '.owl-next' ).toggleClass( 'disabled', currentIndex === milestones.length - 1 );
		}

		function createRollingHTML( content ) {
			return content
				.split( '' )
				.map( ( char ) => `<span class="digit-wrap"><span class="digit">${ char }</span></span>` )
				.join( '' );
		}

		function updateMilestone( index, direction ) {
			if ( ! milestones[ index ] ) {
				return;
			}

			slideDirection = direction === 'next' ? 'up' : 'down';
			const { year, text, img } = milestones[ index ];

			const container = jQuery( '.milestone_data-wrap' );
			const currentYearElem = container.find( '.milestone_cont-year' );
			const textWrap = container.find( '.milestone_text' );
			const textElem = container.find( '.milestone_text p' );
			const imgContainer = container.find( '.milestone_image' );
			const imgElem = imgContainer.find( 'img' );

			const oldHeight = container.outerHeight();
			container.css( 'height', 'auto' );
			const newHeight = container.outerHeight();
			container.css( 'height', oldHeight + 'px' );
			setTimeout( () => {
				container.css( {
					transition: 'height 0.6s ease-in-out',
					height: newHeight + 'px',
				} );
			}, 10 );
			setTimeout( () => {
				container.css( 'height', 'auto' );
			}, 700 );

			const newYearHTML = createRollingHTML( year );
			const newYearElem = jQuery( `<div class="milestone_cont-year new-year">${ newYearHTML }</div>` );
			newYearElem.css( {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '92%',
				pointerEvents: 'none',
			} );
			currentYearElem.parent().css( 'position', 'relative' ).append( newYearElem );

			currentYearElem.find( '.digit' ).each( function( i ) {
				jQuery( this ).delay( i * 40 ).css( {
					transition: `transform 1s ease ${ i * 80 }ms, opacity 1s ease ${ i * 80 }ms`,
				} );
				setTimeout( () => {
					jQuery( this ).css( {
						transform: direction === 'next' ? 'translateY(-100%)' : 'translateY(100%)',
						opacity: 0,
					} );
				}, 0 );
			} );

			const newDigits = newYearElem.find( '.digit' );
			newDigits.css( {
				transform: direction === 'next' ? 'translateY(100%)' : 'translateY(-100%)',
				opacity: 0,
			} );
			newDigits.each( function() {
				void this.offsetHeight;
			} );
			newDigits.each( function( i ) {
				jQuery( this ).css( {
					transform: 'translateY(0)',
					opacity: 1,
					transition: `transform 1s ease ${ i * 100 }ms, opacity 1s ease ${ i * 100 }ms`,
				} );
			} );
			setTimeout( () => {
				currentYearElem.html( newYearHTML );
				newYearElem.remove();
			}, 1200 );

			// Image animation
			const cloneImg = imgElem.clone();
			cloneImg.attr( 'src', img );
			imgContainer.append( cloneImg );
			gsap.set( cloneImg, {
				y: slideDirection === 'up' ? window.innerHeight : -window.innerHeight,
				rotate: -10,
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
			} );
			const directionY = slideDirection === 'up' ? -window.innerHeight : window.innerHeight;
			const timeline = gsap.timeline( {
				onStart() {
					jQuery( '.draw-illustration' ).each( function() {
						const svgItem = jQuery( this );
						svgItem.css( 'display', 'none' );
						gsap.set( svgItem, { drawSVG: '100% 100%' } );
					} );
				},
				onComplete() {
					imgElem.attr( 'src', img );
					gsap.set( imgElem, { y: 0, rotate: -10 } );
					cloneImg.remove();
					setTimeout( () => {
						jQuery( '.draw-illustration' ).each( function() {
							const svgItem = jQuery( this );
							svgItem.css( 'display', 'block' );
							gsap.to( svgItem, {
								drawSVG: '100% 0',
								duration: 1.5,
								ease: 'none',
							} );
						} );
					}, 100 );
				},
			} );

			timeline.to( imgElem, {
				y: directionY,
				rotate: 10,
				duration: 1.5,
				ease: 'power3.out',
			}, 0 ).to( cloneImg, {
				y: 0,
				rotate: -10,
				duration: 1.5,
				ease: 'power3.out',
			}, 0.2 );

			// Text animation
			gsap.to( textElem, {
				opacity: 0,
				duration: 0.3,
				onComplete() {
					setTimeout( () => {
						textElem.html( text );
						gsap.fromTo( textElem, { opacity: 0 }, { opacity: 1, duration: 1, delay: 0.3 } );
					}, 300 );
				},
			} );

			updateCounter();
			updateNavButtons();
		}

		function autoSlide() {
			if ( currentIndex < milestones.length - 1 ) {
				currentIndex++;
				updateMilestone( currentIndex, 'next' );
				jQuery( '.owl-dot' ).removeClass( 'active' );
				jQuery( `.owl-dot[data-index="${ currentIndex }"]` ).addClass( 'active' );
			} else {
				clearInterval( autoSlideInterval ); // stop auto slide at end
			}
		}

		function startAutoSlide() {
			clearInterval( autoSlideInterval );
			autoSlideInterval = setInterval( autoSlide, 8000 );
		}

		jQuery( document ).on( 'click', '.owl-dot', function() {
			const index = parseInt( jQuery( this ).attr( 'data-index' ) );
			const direction = index > currentIndex ? 'next' : 'prev';
			currentIndex = index;
			jQuery( '.owl-dot' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			updateMilestone( currentIndex, direction );
			startAutoSlide();
		} );

		jQuery( document ).on( 'click', '.owl-next', function() {
			if ( currentIndex < milestones.length - 1 ) {
				currentIndex++;
				updateMilestone( currentIndex, 'next' );
				jQuery( '.owl-dot' ).removeClass( 'active' );
				jQuery( `.owl-dot[data-index="${ currentIndex }"]` ).addClass( 'active' );
				startAutoSlide();
			}
		} );

		jQuery( document ).on( 'click', '.owl-prev', function() {
			if ( currentIndex > 0 ) {
				currentIndex--;
				updateMilestone( currentIndex, 'prev' );
				jQuery( '.owl-dot' ).removeClass( 'active' );
				jQuery( `.owl-dot[data-index="${ currentIndex }"]` ).addClass( 'active' );
				startAutoSlide();
			}
		} );

		jQuery( window ).on( 'resize', updateCounter );

		jQuery( `.owl-dot[data-index="0"]` ).addClass( 'active' );
		updateMilestone( 0, 'next' );
		startAutoSlide();
		updateCounter();
	}
	function reInitTestimonials() {
		jQuery( '.theme-quotes' ).each( function() {
			const $this = jQuery( this );
			const isWide = $this.hasClass( 'theme-quote-wide' );

			if ( isWide ) {
				$this.slick( 'unslick' );
				$this.slick( {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					dots: true,
					autoplay: true,
					autoplaySpeed: 8000,
					infinite: false,
				} );

				const total = ( '0' + $this.slick( 'getSlick' ).slideCount ).slice( -2 );
				jQuery( '.wide-slide-count .wide-total-slides' ).text( total );

				$this.on( 'afterChange', function( event, slick, currentSlide ) {
					const current = ( '0' + ( currentSlide + 1 ) ).slice( -2 );
					jQuery( '.wide-slide-count .wide-current-slide' ).text( current );
				} );

				const current = ( '0' + 1 ).slice( -2 );
				jQuery( '.wide-slide-count .wide-current-slide' ).text( current );
			} else {
				$this.owlCarousel( {
					loop: true,
					margin: 126,
					nav: true,
					dots: true,
					autoplay: true,
					autoplayTimeout: 8000,
					items: 1,
				} );
			}
		} );

		setTimeout( () => {
			if ( jQuery( '.theme-quote-wide' ).length > 0 ) {
				jQuery( '.theme-quote-wide .slick-prev' ).append( `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                <path d="M0.346874 9.81538C0.126562 9.60444 0 9.30912 0 8.99975C0 8.69038 0.126562 8.39975 0.346874 8.18413L8.59687 0.309126C9.04687 -0.122124 9.75938 -0.103374 10.1859 0.346626C10.6125 0.796626 10.5984 1.50913 10.1484 1.93569L3.93281 7.87475H18.875C19.4984 7.87475 20 8.37631 20 8.99975C20 9.62319 19.4984 10.1248 18.875 10.1248H3.93281L10.1531 16.0591C10.6031 16.4904 10.6172 17.1982 10.1906 17.6482C9.76406 18.0982 9.05156 18.1123 8.60156 17.6857L0.351562 9.81069L0.346874 9.81538Z" fill="#243B4A"/>
            </svg>
        ` );

				jQuery( '.theme-quote-wide .slick-next' ).append( `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                <path d="M19.6531 9.81538C19.8734 9.60444 20 9.30912 20 8.99975C20 8.69038 19.8734 8.39975 19.6531 8.18413L11.4031 0.309126C10.9531 -0.122124 10.2406 -0.103374 9.81406 0.346626C9.3875 0.796626 9.40156 1.50913 9.85156 1.93569L16.0672 7.87475H1.125C0.501562 7.87475 0 8.37631 0 8.99975C0 9.62319 0.501562 10.1248 1.125 10.1248H16.0672L9.84687 16.0591C9.39687 16.4904 9.38281 17.1982 9.80938 17.6482C10.2359 18.0982 10.9484 18.1123 11.3984 17.6857L19.6484 9.81069L19.6531 9.81538Z" fill="#243B4A"/>
            </svg>
        ` );
			}
		}, 300 );
	}

	reInitTestimonials();
} );

